export default "__VITE_ASSET__BrKpKrPi__"